import React from "react";
import { SquareAvatar } from "../../../components/images/SquareAvatar";
import FeatherIcon from "feather-icons-react";
import TruncateFade from "../../../components/TruncateFade";
import { chipsMatchEntity, searchStateClass } from "../../../utils/searchMatch";

export default function PlayersGridView({
                                            players,
                                            tournament,
                                            is_authorized,
                                            onAction,
                                            lastElementRef,
                                            searchChips,
                                            teamNameDraft,
                                            setTeamNameDraft,
                                            onOpenRating,
                                            ordering,
                                            t
                                        }) {
    const { grade, player_quantity, team_size } = tournament;
    const slotSize = grade === 1 ? 1 : grade === 2 ? 2 : team_size;

    const renderCard = (index) => {
        const item = players[index];
        const isLast = players.length > 0 && index === players.length - 1;
        const matched = chipsMatchEntity(searchChips, {
            names: grade === 1 ? [item] : [item?.name, ...(item?.players || [])]
        });

        const rows = grade === 1
            ? [item || null]
            : Array.from({ length: slotSize }).map((_, i) => (item?.players || []).find(p => p?.sorting === i) || null);

        const totalRating =
            item?.team_rating ??
            rows.reduce((acc, p) => acc + (p?.rating || 0), 0);

        const hasPlayers = rows.some(p => p);

        return (
            <div className={`player-grid-card ${searchStateClass(matched)}`} key={index} ref={isLast ? lastElementRef : null}>
                {grade > 1 ? (
                    <div className="team-card-header rating-card-header no-line">
                        <div className="team-card-header-left">
                            <span className="team-card-number">
                                #{item?.number || (ordering === "-created_at" ? player_quantity - index : index + 1)}
                            </span>
                            {grade === 3 && (
                                is_authorized ? (
                                    <input
                                        type="text"
                                        className="team-name-input"
                                        value={(item?.id ? teamNameDraft[item.id] : undefined) ?? item?.name ?? ""}
                                        onChange={(e) => {
                                            if (!item || !item.id) return;
                                            setTeamNameDraft(prev => ({
                                                ...prev,
                                                [item.id]: e.target.value
                                            }));
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        placeholder={t("Enter team name")}
                                    />
                                ) : (
                                    <span className="team-name-display">{item?.name ?? ""}</span>
                                )
                            )}
                        </div>
                        {((tournament?.rating && hasPlayers) || (is_authorized && item?.id)) && (
                            <div className="team-card-header-right">
                                {tournament?.rating && hasPlayers && (
                                    <span className="team-card-rating">
                                        <FeatherIcon icon="bar-chart-2" size={12} />{totalRating}
                                    </span>
                                )}
                                {is_authorized && item?.id && (
                                    <span
                                        className="delete-team"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onAction('delete_team', { teamId: item.id });
                                        }}
                                    >
                                        <FeatherIcon icon="x" size={14} />
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    // Same team-card-header/team-card-number/team-card-rating
                    // classes as the team branch above (and Результати's own
                    // singles grid card), instead of the old float-based
                    // ul.tabs/card-badge markup, which sat right at the
                    // card's raw 3px padding with no breathing room and read
                    // as cramped next to the now-roomier team cards. "no-line"
                    // unconditionally, not just for non-admins: singles never
                    // has an admin-only control here to justify the divider
                    // or the height it reserves, unlike the team header's
                    // delete-team button.
                    <div className="team-card-header rating-card-header no-line">
                        <div className="team-card-header-left">
                            <span className="team-card-number">
                                #{index + 1}
                            </span>
                        </div>
                        {item && tournament.rating && (
                            <div className="team-card-header-right">
                                <span
                                    className={`team-card-rating${onOpenRating ? " cursor" : ""}`}
                                    onClick={onOpenRating ? (e) => {
                                        e.stopPropagation();
                                        onOpenRating(item.player_id || item.id);
                                    } : undefined}
                                >
                                    <FeatherIcon icon="bar-chart-2" size={12} />{totalRating}
                                </span>
                            </div>
                        )}
                    </div>
                )}

                <table style={{ width: '100%', tableLayout: 'fixed' }}>
                    <tbody>
                    <tr>
                        {rows.map((p, i) => (
                            <td key={i} style={{ position: 'relative' }} onClick={() => onAction('edit_slot', { index, slot: i, player: p })}>
                                {p ? <SquareAvatar src={p?.image}/>
                                : is_authorized ?
                                        <div className="square-no-thumbnail"><FeatherIcon icon="plus" /></div>
                                    : <div className="square-no-thumbnail"><FeatherIcon icon="camera-off" /></div>
                                }
                                    <div className="mini-name black-name">
                                        {/*{p?.level && (*/}
                                        {/*<div className="player-level">*/}
                                        {/*    <span className="level">*/}
                                        {/*        {t(getOptionName(LEVEL_OPTIONS, p.level))}*/}
                                        {/*    </span>*/}
                                        {/*</div>*/}
                                        {/*)}*/}
                                        {/*{p ? <><span className="uppercase"><Truncated text={p.last_name} /></span><br/>{p.first_name}</> :*/}
                                        {/*    t("Player")}*/}
                                        {/*    /!*>+ {t("Player")}</span></> : t("Player")}*!/*/}
                                        {p ? (
                                            <>
                                                <TruncateFade text={p.last_name} className="uppercase" />
                                                <br/>
                                                <TruncateFade text={p.first_name} />
                                            </>
                                        ) :

                                            <>
                                                { tournament.rating ? <><span style={{ visibility: 'hidden' }}>_</span><br/></> : <div style={{height: "8px"}}></div> }
                                                <span className="secondary-color">{t("Player")}</span>
                                            </>
                                        //     (
                                        //     <>
                                        //         { tournament.rating ? <><span style={{ visibility: 'hidden' }}>_</span><br/></> : <div style={{height: "8px"}}></div> }
                                        //         {is_authorized
                                        //             ? <div className="cursor add-score">+ {t("Player")}</div>
                                        //             : <div>{t("Player")}</div>
                                        //         }
                                        //     </>
                                        // )
                                        }
                                    </div>

                                {p && tournament.rating && grade > 1 && (
                                    <div
                                        className={`grid-rating grid-rating-player${onOpenRating ? " cursor" : ""}`}
                                        onClick={onOpenRating ? (e) => {
                                            e.stopPropagation();
                                            onOpenRating(p.player_id || p.id);
                                        } : undefined}
                                    >
                                        <FeatherIcon icon="bar-chart-2" size={12} />{p?.rating ? p.rating : 0}
                                    </div>
                                )}
                            </td>
                        ))}
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className={`players-grid${grade === 1 ? " players-grid-singles" : ""}`} style={{ '--slot-size': slotSize }}>
            {Array.from({ length: player_quantity }).map((_, index) => renderCard(index))}
        </div>
    );
}